import { render, staticRenderFns } from "./settingModal.vue?vue&type=template&id=1c4a5379&"
import script from "./settingModal.vue?vue&type=script&lang=js&"
export * from "./settingModal.vue?vue&type=script&lang=js&"
import style0 from "./settingModal.vue?vue&type=style&index=0&scopped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports